<template>
  <p-panel-properties-group
    v-if="glossaryHasTerms"
    :title="title"
    action-icon
    :action-icon-id="actionId"
  >
    <p-panel-properties three-line>
      <GlossaryTermItem
        v-for="term in terms"
        :key="getCustomId(term)"
				:term="term"
				:mode="mode"
        :allow-remove="allowRemove"
        @open="$emit('open', term)"
        @remove="$emit('remove', term)"
      />
    </p-panel-properties>

    <template v-if="showDeleteGlossaryAction" v-slot:actionIcon>
      <v-btn flat icon>
        <v-icon color="red" @click="$emit('delete-group')">
          mdi-trash-can-outline
        </v-icon>
      </v-btn>
    </template>
  </p-panel-properties-group>
</template>

<script>
import PPanelProperties from "../../../lessonPlan/blocks/_components/utils/PPanelProperties.vue"
import PPanelPropertiesGroup from "../../../lessonPlan/blocks/_components/utils/PPanelPropertiesGroup.vue"
import GlossaryTermItem from "./GlossaryTermItem.vue"

import { getCustomId } from "../../../../utils/dbTool"

export default {
  name: "GlossaryGroup",
  components: { PPanelProperties, PPanelPropertiesGroup, GlossaryTermItem },
  props: {
    title: {
      type: String,
      required: true
    },
    actionId: {
      type: String,
      required: true
    },
    terms: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: "view"
    },
    allowRemove: {
      type: Boolean,
      default: true
    },
    canDeleteGlossary: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    glossaryHasTerms() {
      return this.terms && this.terms.length
    },
    showDeleteGlossaryAction() {
      return this.mode === 'edit' && this.canDeleteGlossary
    }
  },
  methods: {
    getCustomId
  }
}
</script>
